import React from 'react'

import BrowserLocationHelper from '../../../utils/browser_location_helper';

import style from "./ForgotPasswordLink.module"

function gotoForgetURL(event) {
    if (event) { event.preventDefault(); }

    const URL = "/" + I18n.locale + "/user/password/new";

    BrowserLocationHelper.ChangeURL(URL);
}


export default function ForgotPasswordLink() {
    return (
        <div className={style.link}>
            <a onClick={gotoForgetURL} href="#">{I18n.t('pages.user_session.links.forgot_password')}</a>
        </div>
    )
}
